import * as React from "react"

import { cn } from "@/shared/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-earth-200 dark:bg-earth-700", className)}
      {...props}
    />
  )
}

export { Skeleton }
